import apCoin from "../../assets/images/apcoin.png";

interface Props {
  apoints: number;
  className?: string;
  label?: string;
}

const APCoins = ({
  className = "",
  apoints,
  label = "Atlantis Points:",
}: Props) => {
  return (
    <div
      className={`relative p-[1px] rounded-md bg-gradient-to-r from-[#48A7FF] to-transparent gilroy-font ${className}`}
    >
      <img
        src={apCoin}
        alt="apcoins"
        className="absolute top-[50%] translate-y-[-50%] min-w-[110px] left-[-60px] object-contain"
      />

      <div className="rounded-md bg-gradient-to-r from-[#346899] to-[#2a4a69] py-1 min-w-[160px]">
        <div className="pl-10">
          <p className=" text-[0.8rem]  text-white/60 ">{label}</p>
          <span className="text-[1rem] text-white font-semibold leading-[.8]">
            {apoints}
          </span>
        </div>
      </div>
    </div>
  );
};

export default APCoins;
